<template>
  <GenericModal
    unique-id="cookies-modal"
    modalOpenTriggerHandlerId="cookies-modal-open"
    modalCloseTriggerHandlerId="cookies-modal-close"
    ref="cookiesModal"
    class="cookie-modal-container"
    id="CookieModalContainer"
    width="100%"
    height="auto"
    overflow="auto"
    backgroundBlur="none"
    close-btn-position="in"
    :render-overlay="false"
  >
    <cookie-notice v-show="getCookieNoticeVisible"></cookie-notice>
    <cookie-settings v-show="getCookieSettingsVisible"></cookie-settings>
  </GenericModal>
</template>

<script>
import CookieSettings from './CookieSettings'
import CookieNotice from './CookieNotice'
import { mapGetters } from 'vuex'
import GenericModal from '../../presentation/GenericModal.vue'
import cookiesModalMixin from '../mixins/cookiesModalMixin'

export default {
  name: 'CookieModal',
  mixins: [
    cookiesModalMixin
  ],
  components: {
    GenericModal,
    CookieSettings,
    CookieNotice
  },
  computed: {
    ...mapGetters('cookies', [
      'getCookieNoticeVisible',
      'getCookieSettingsVisible'
    ])
  }
}
</script>

<style lang="scss" scoped>
::v-deep .cp-utilities-generic_modal-overlay-close {
  display: none;
}
::v-deep .cp-utilities-generic_modal {
  padding: 0.5rem;
}
</style>
